<div class="content-container h-full flex flex-col justify-between">
  <div>
    @if (isLoading()) {
      <lib-overlay-loader />
    }

    <header class="py-lg flex items-center">
      <h1 class="text-xl leading-7 font-semibold text-neutral-900">
        {{ pageTitle() }}
      </h1>
    </header>

    <form [formGroup]="groupFormGroup()" libScrollToError>
      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 my-2xl">
          {{ 'group_form_screen_group_image_section_title' | transloco }}
        </h5>

        <div class="image-section">
          <div>
            <lib-upload-files
              [uploadedFiles]="editMode() ? uploadedImage() : []"
              [id]="'image'"
              [name]="'image'"
              [uploadUrl]="uploadFileUrls.upload"
              [removeUrl]="uploadFileUrls.remove"
              [label]="'group_form_screen_upload_image_label' | transloco"
              [inputFormControlName]="'image'"
              [accept]="'jpg,jpeg,png,webp'"
              [multiple]="false"
              [fileSizeLimit]="2048 * 1000"
              [viewOnly]="false"
              [required]="false"
              [uploadedFileLimit]="1"
              [uploadFileLabels]="{
                placeholder: 'upload_files_placeholder' | transloco,
                singleFileAttachedLabel:
                  'upload_files_single_file_attached_label' | transloco,
                multipleFilesAttachedLabel:
                  'upload_files_multiple_files_attached_label' | transloco,
                addMoreLabel: 'upload_files_add_more_label' | transloco,
                attachmentsTitle: 'upload_files_attachments_title' | transloco,
                fileUploadTitle: 'upload_files_file_upload_title' | transloco,
                dragAndDropLabel:
                  'upload_files_drag_and_drop_label' | transloco,
                orLabel: 'upload_files_or_label' | transloco,
                uploadFromComputerLabel:
                  'upload_files_upload_from_computer_label' | transloco,
                maxSizeLabel: 'upload_files_max_size_label' | transloco,
                perFileLabel: 'upload_files_per_file_label' | transloco,
                maxFilesLimitLabel:
                  'upload_files_max_files_limit_label' | transloco,
                cancelButtonLabel:
                  'upload_files_cancel_button_label' | transloco,
                continueButtonLabel:
                  'upload_files_continue_button_label' | transloco,
                singleFileUploadedLabel:
                  'upload_files_single_file_uploaded_label' | transloco,
                multipleFilesUploadedLabel:
                  'upload_files_multiple_files_uploaded_label' | transloco,
                singleFileLabel: 'upload_files_single_file_label' | transloco,
                multipleFilesLabel:
                  'upload_files_multiple_files_label' | transloco,
                allFormatsAcceptedLabel:
                  'upload_files_all_formats_accepted_label' | transloco,
                acceptedFormatLabel:
                  'upload_files_accepted_format_label' | transloco,
                acceptedFormatsLabel:
                  'upload_files_accepted_formats_label' | transloco,
                uploadedLabel: 'upload_files_uploaded_label' | transloco,
                deleteWarningPopupTitle:
                  'group_form_screen_upload_image_warning_popup_title'
                  | transloco,
                deleteWarningPopupDeclaimerMessage:
                  'upload_image_warning_popup_declaimer_message' | transloco,
                deleteWarningPopupCancelButton:
                  'upload_image_warning_popup_cancel_button' | transloco,
                deleteWarningPopupContinueButton:
                  'upload_image_warning_popup_delete_button' | transloco,
              }" />
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="image" />
          </div>
        </div>
      </section>

      <section>
        <h5
          class="text-neutral-900 font-semibold text-lg py-lg border-b border-neutral-200 my-2xl">
          {{ 'group_form_screen_group_info_section_title' | transloco }}
        </h5>

        <div class="info-section gap-lg">
          <div>
            <div formGroupName="name">
              <dual-lang-input
                [requiredGroup]="true"
                [inputFormControlName]="'name'"
                [id]="'name'"
                type="text"
                name="name"
                [requiredEn]="false"
                [requiredAr]="false"
                [label]="'group_form_screen_group_name_label' | transloco"
                [placeholderEn]="
                  'group_form_screen_group_name_placeholder_en' | transloco
                "
                [placeholderAr]="
                  'group_form_screen_group_name_placeholder_ar' | transloco
                " />
            </div>
            <lib-validation-message
              [lang]="'current_lang' | transloco"
              control="name" />
          </div>
        </div>
      </section>
    </form>
  </div>

  <div class="mt-5xl">
    <div
      class="flex items-center justify-between border-b border-neutral-200 pb-lg">
      <div class="flex items-center gap-lg">
        <h6 class="font-semibold text-lg text-neutral-900">
          {{ 'group_form_screen_assigned_users_section_title' | transloco }}
        </h6>

        <span class="bg-primary-50 rounded-2xl">
          <p class="text-primary-700 px-md py-x-sm font-medium">
            {{ assignedListTotal() }}
          </p>
        </span>
      </div>

      <div>
        <button
          (click)="openAssignGroupUsersDialog()"
          class="bg-primary-500 text-white font-medium text-sm py-sm px-lg border-none rounded-md gap-sm flex items-center"
          id="group_form_screen_assign_button">
          <lib-add-icon [iconClass]="'size-5 text-white'" />

          {{ 'group_form_screen_assign_button' | transloco }}
        </button>
      </div>
    </div>

    <div class="my-lg">
      @if (isAssignedListLoading()) {
        <div class="flex justify-center items-center h-full my-4xl">
          <lib-loader />
        </div>
      } @else {
        <lib-group-user-card
          [list]="assignedList()"
          [itemType]="'User'"
          [mode]="'edit'"
          (unselectGroupUser)="removeAssignedItem($event)" />
      }

      @if (
        (assignedList().length || assignedListCurrentPage() > 1) && groupId()
      ) {
        <div class="mt-2xl">
          <lib-paginator
            [sizeOptionsLabel]="
              'pagination_number_of_rows_per_page_label' | transloco
            "
            [nextBtnLabel]="'pagination_next_button_label' | transloco"
            [previousBtnLabel]="'pagination_previous_button_label' | transloco"
            [currentPage]="assignedListCurrentPage()"
            [totalPages]="assignedListTotalPages()"
            [totalItems]="assignedListTotal()"
            [currentSize]="15"
            (goTo)="handleAssignedListPagination($event)"
            (next)="handleAssignedListPagination($event)"
            (previous)="handleAssignedListPagination($event)" />
        </div>
      }
    </div>
  </div>

  <footer class="flex justify-end items-end pb-2xl">
    <div class="flex justify-end gap-lg mt-4xl">
      <a
        id="cancel"
        class="px-lg py-sm rounded-md text-neutral-700 bg-white text-lg font-medium cursor-pointer"
        [routerLink]="[
          editMode()
            ? (`${ADMIN_ROUTES.GROUPS.DETAILS}/${groupId()}`
              | tenantPath: 'admin')
            : (`${ADMIN_ROUTES.GROUPS.LIST}` | tenantPath: 'admin'),
        ]">
        {{ 'group_form_screen_cancel_button' | transloco }}
      </a>

      <button
        id="submit"
        class="px-lg py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none cursor-pointer"
        (click)="submit()"
        [class.opacity-30]="isLoading()"
        [disabled]="isLoading()">
        {{ buttonText() }}
      </button>
    </div>
  </footer>
</div>

<ng-template #assignGroupUsersDialog>
  <lib-assign-group-users
    [groupUsersCards]="lookupList()"
    [selectedGroupUsersCards]="selectedList()"
    (selectGroupUser)="selectItem($event)"
    (unselectGroupUser)="removeSelectedItem($event)"
    (saveAssignedGroupUsers)="saveAssignedItems()"
    (filterGroupUsersCards)="getGroupUsers($event)"
    (paginateGroupUsersCards)="getGroupUsers('', $event)"
    [isLoading]="isLoadingGroupUsers()"
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    [itemType]="'User'" />
</ng-template>
